import { render, staticRenderFns } from "./TasksSidebar.vue?vue&type=template&id=3563ed36"
import script from "./TasksSidebar.vue?vue&type=script&lang=js"
export * from "./TasksSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports